/*
  Datei-Dropzone für das Installateursportal (Michel 29.09.2026), nach „Upload dropzone“
  von Bencho (MIT, bencho.dev/licence), ohne React und framer-motion auf Shopify übertragen,
  hell und in den Farben von SolarOutlet.

  Macht aus jedem <label class="inst-datei"> mit <input type="file"> eine Ablagefläche.
  Das echte Dateifeld bleibt im Formular (unsichtbar, aber per Tastatur erreichbar), die
  vorhandene Logik liest es wie bisher. Hochladen tut dieses Skript selbst nicht.

  ── DIE BOX ATMET EIN UND SCHLUCKT ─────────────────────────
  Eine gefüllte Fläche ohne Rand. Wird eine Datei darüber gezogen, antwortet sie schon vor
  dem Loslassen: sie wächst mit einem kleinen Nachfedern und der Pfeil hebt sich zur Hand.
  Loslassen, und die Box macht einen kleinen Schluck, bevor die Datei in ihr erscheint.

  ── ZU GROSS ODER FALSCHER TYP ─────────────────────────────
  Die Box schüttelt sich, sagt es in Rot und bleibt leer. Die Grenze kommt aus data-max-mb
  am Label (Standard 10), die erlaubten Typen aus dem accept des Dateifelds.

  ── FORTSCHRITT ────────────────────────────────────────────
  Wer hochlädt, ruft am Label:
    label.instDropzone.fortschritt(0..1)   rollende Prozentzahl und Balken
    label.instDropzone.fertig()            Haken
    label.instDropzone.zurueck(text?)      wieder auswählbar, optional mit Fehlertext
    label.instDropzone.leeren(text?)       leer für die nächste Datei (mehrere Dateien nacheinander)
  Ohne diese Aufrufe zeigt die Box nur die gewählte Datei.

  ── EREIGNISSE ─────────────────────────────────────────────
  Am Label: „inst-dz:datei“ (detail.datei) sobald eine gültige Datei gewählt oder abgelegt
  ist, „inst-dz:weg“ wenn sie entfernt wird. So kann die Seite sofort hochladen (Michel 29.09.).
  Liegt eine Datei in der Box oder läuft ein Upload, öffnet ein Klick nicht noch einmal die
  Auswahl: ein abgebrochener Dialog leert in Chrome sonst das Feld.
*/
(function () {
  'use strict';

  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var PFEIL = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m17 8-5-5-5 5"/><path d="M12 3v12"/></svg>';
  var HAKEN = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var ENTFERNEN = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  /* Farbe der Endung: sie trägt die Art, bevor das Wort gelesen ist (nach Untitled UI) */
  function art(datei) {
    var t = (datei.type || '').toLowerCase();
    var n = (datei.name.split('.').pop() || '').toUpperCase().slice(0, 4);
    if (t === 'application/pdf') return { ext: 'PDF', farbe: '#d92d20' };
    if (t.indexOf('image/') === 0) return { ext: n === 'JPEG' ? 'JPG' : (n || 'BILD'), farbe: '#00453c' };
    return { ext: n || 'DATEI', farbe: '#475467' };
  }

  function groesse(b) { return b >= 1e6 ? (b / 1e6).toFixed(1).replace('.', ',') + ' MB' : Math.max(1, Math.round(b / 1e3)) + ' KB'; }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* die Seite mit Eselsohr, die Endung auf einem Schild, das links über die Seite hinausragt */
  function seite(a) {
    return '<svg class="inst-dz__seite" width="36" height="36" viewBox="0 0 40 40" fill="none" aria-hidden="true">' +
      '<path class="inst-dz__seitenlinie" d="M7.75 4A3.25 3.25 0 0 1 11 .75h16c.121 0 .238.048.323.134l10.793 10.793a.46.46 0 0 1 .134.323v24A3.25 3.25 0 0 1 35 39.25H11A3.25 3.25 0 0 1 7.75 36z"/>' +
      '<path class="inst-dz__seitenlinie" d="M27 .5V8a4 4 0 0 0 4 4h7.5"/>' +
      '<rect width="29" height="16" x="1" y="18" rx="8" fill="' + a.farbe + '"/>' +
      '<text x="15.5" y="29.3" text-anchor="middle" class="inst-dz__ext">' + esc(a.ext) + '</text></svg>';
  }

  /* rollende Ziffern: jede Stelle ein Streifen 0 bis 9, der verschoben wird */
  function rolle(wert) {
    var s = String(Math.round(wert));
    return '<span class="inst-dz__rolle" aria-hidden="true">' + s.split('').map(function (d) {
      return '<span class="inst-dz__spalte"><span class="inst-dz__streifen" style="transform:translateY(' + (-Number(d)) + 'em)">' +
        '0123456789'.split('').map(function (n) { return '<span>' + n + '</span>'; }).join('') + '</span></span>';
    }).join('') + '%</span>';
  }

  function Dropzone(label) {
    var ich = this;
    this.label = label;
    this.input = label.querySelector('input[type="file"]');
    this.maxMb = Number(label.getAttribute('data-max-mb')) || 10;
    this.erlaubt = (this.input.getAttribute('accept') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var titel = label.querySelector(':scope > span');
    this.titel = titel ? titel.textContent : '';
    if (titel) titel.classList.add('inst-dz__titel');

    label.classList.add('inst-dz');
    this.input.classList.add('inst-dz__eingabe');
    this.flaeche = document.createElement('span');
    this.flaeche.className = 'inst-dz__flaeche';
    this.flaeche.setAttribute('aria-live', 'polite');
    label.appendChild(this.flaeche);
    this.leer();

    this.input.addEventListener('change', function () {
      var d = ich.input.files && ich.input.files[0];
      // abgebrochene Auswahl bei schon gewählter Datei: die alte bleibt
      if (!d && ich.datei) return;
      ich.gewaehlt(d);
    });
    label.addEventListener('click', function (e) {
      if (e.target.closest('.inst-dz__weg')) return;
      if (label.dataset.datei || label.dataset.laeuft) e.preventDefault();
    });
    this.input.addEventListener('focus', function () { label.dataset.fokus = '1'; });
    this.input.addEventListener('blur', function () { delete label.dataset.fokus; });

    /* Zählt Eintritte, weil dragleave auch beim Wechsel auf Kindelemente feuert */
    var tiefe = 0;
    label.addEventListener('dragenter', function (e) { if (!ich.hatDateien(e)) return; e.preventDefault(); tiefe++; ich.ueber(true); });
    label.addEventListener('dragover', function (e) { if (!ich.hatDateien(e)) return; e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; });
    label.addEventListener('dragleave', function () { tiefe = Math.max(0, tiefe - 1); if (!tiefe) ich.ueber(false); });
    label.addEventListener('drop', function (e) {
      if (!ich.hatDateien(e)) return;
      e.preventDefault();
      tiefe = 0;
      ich.ueber(false);
      var d = e.dataTransfer.files[0];
      if (!d) return;
      if (!ich.pruefen(d)) return;
      try {
        var dt = new DataTransfer();
        dt.items.add(d);
        ich.input.files = dt.files;
      } catch (_) { /* alter Browser: dann bleibt nur das Auswählen */ ich.ablehnen('Bitte über „auswählen“ wählen.'); return; }
      ich.schluck();
      ich.gewaehlt(d, true);
    });

    label.instDropzone = this;
  }

  Dropzone.prototype.hatDateien = function (e) {
    var t = e.dataTransfer && e.dataTransfer.types;
    return !!t && Array.prototype.indexOf.call(t, 'Files') !== -1 && !this.label.dataset.laeuft;
  };

  Dropzone.prototype.ueber = function (an) {
    if (an) this.label.dataset.ueber = '1'; else delete this.label.dataset.ueber;
    var b = this.flaeche.querySelector('.inst-dz__sagt b');
    if (b && !this.label.dataset.nein) b.textContent = an ? 'Loslassen zum Übernehmen' : (this.leerText || 'Datei hierher ziehen');
  };

  Dropzone.prototype.leer = function (fehler) {
    delete this.label.dataset.datei;
    this.flaeche.innerHTML =
      '<span class="inst-dz__icon">' + PFEIL + '</span>' +
      '<span class="inst-dz__sagt"><b>' + (fehler ? esc(fehler) : esc(this.leerText || 'Datei hierher ziehen')) + '</b>' +
      '<span>oder <u>auswählen</u> · PDF oder Foto, bis ' + this.maxMb + ' MB</span></span>';
  };

  Dropzone.prototype.pruefen = function (d) {
    if (this.erlaubt.length && this.erlaubt.indexOf(d.type) === -1) { this.ablehnen('Nur PDF, JPG, PNG oder WebP'); return false; }
    if (d.size > this.maxMb * 1024 * 1024) { this.ablehnen('Zu groß, höchstens ' + this.maxMb + ' MB'); return false; }
    return true;
  };

  /* Nein: schütteln, rot sagen, nach einer Weile wieder freundlich */
  Dropzone.prototype.ablehnen = function (text) {
    var ich = this;
    this.input.value = '';
    this.label.dataset.nein = '1';
    this.leer(text);
    if (!still) {
      this.label.classList.remove('inst-dz--schuetteln');
      void this.label.offsetWidth;
      this.label.classList.add('inst-dz--schuetteln');
    }
    clearTimeout(this.neinZeit);
    this.neinZeit = setTimeout(function () {
      delete ich.label.dataset.nein;
      if (!ich.label.dataset.datei) ich.leer();
    }, 2600);
  };

  Dropzone.prototype.schluck = function () {
    var l = this.label;
    if (still) return;
    l.classList.remove('inst-dz--schluck');
    void l.offsetWidth;
    l.classList.add('inst-dz--schluck');
    setTimeout(function () { l.classList.remove('inst-dz--schluck'); }, 480);
  };

  Dropzone.prototype.gewaehlt = function (d, schonGeprueft, ohneMeldung) {
    var ich = this;
    if (!d) { this.leer(); return; }
    if (!schonGeprueft && !this.pruefen(d)) return;
    this.datei = d;
    this.label.dataset.datei = '1';
    this.flaeche.innerHTML =
      '<span class="inst-dz__jetzt">' + seite(art(d)) +
        '<span class="inst-dz__text">' +
          '<span class="inst-dz__name">' + esc(d.name) + '</span>' +
          '<span class="inst-dz__meta">' + groesse(d.size) + ' · <span data-dz-stand>bereit</span></span>' +
          '<span class="inst-dz__spur"><span class="inst-dz__balken" data-dz-balken></span></span>' +
        '</span>' +
        /* der Platz für Haken oder Entfernen ist von Anfang an da, damit nichts springt */
        '<span class="inst-dz__ende"><button type="button" class="inst-dz__weg" aria-label="Datei entfernen">' + ENTFERNEN + '</button></span>' +
      '</span>';
    this.flaeche.querySelector('.inst-dz__weg').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      ich.input.value = '';
      ich.datei = null;
      delete ich.label.dataset.laeuft;
      delete ich.label.dataset.fertig;
      ich.leer();
      ich.label.dispatchEvent(new CustomEvent('inst-dz:weg', { bubbles: true }));
    });
    // nur bei einer neuen Wahl melden, nicht beim Zurücksetzen nach einem Fehler (sonst Upload-Schleife)
    if (!ohneMeldung) this.label.dispatchEvent(new CustomEvent('inst-dz:datei', { bubbles: true, detail: { datei: d } }));
  };

  Dropzone.prototype.fortschritt = function (p) {
    this.label.dataset.laeuft = '1';
    var stand = this.flaeche.querySelector('[data-dz-stand]');
    var balken = this.flaeche.querySelector('[data-dz-balken]');
    var weg = this.flaeche.querySelector('.inst-dz__weg');
    if (weg) weg.hidden = true;
    p = Math.max(0, Math.min(1, p || 0));
    if (stand) stand.innerHTML = rolle(p * 100) + '<span class="inst-dz__versteckt">' + Math.round(p * 100) + ' %</span>';
    if (balken) balken.style.transform = 'scaleX(' + p + ')';
  };

  Dropzone.prototype.fertig = function () {
    this.fortschritt(1);
    var stand = this.flaeche.querySelector('[data-dz-stand]');
    var ende = this.flaeche.querySelector('.inst-dz__ende');
    if (stand) stand.textContent = 'hochgeladen';
    if (ende) {
      var weg = ende.querySelector('.inst-dz__weg');
      ende.insertAdjacentHTML('afterbegin', '<span class="inst-dz__haken">' + HAKEN + '</span>');
      // nach dem Haken bleibt das Entfernen möglich, bis abgesendet ist
      if (weg) setTimeout(function () { var h = ende.querySelector('.inst-dz__haken'); if (h) h.remove(); weg.hidden = false; }, 1400);
    }
    delete this.label.dataset.laeuft;
    this.label.dataset.fertig = '1';
  };

  /* Nach einem fertigen Upload: Box leeren, damit die nächste Datei hinein kann */
  Dropzone.prototype.leeren = function (text) {
    this.input.value = '';
    this.datei = null;
    delete this.label.dataset.laeuft;
    delete this.label.dataset.fertig;
    if (text) this.leerText = text;
    this.leer();
    this.schluck();
  };

  Dropzone.prototype.zurueck = function (fehler) {
    delete this.label.dataset.laeuft;
    delete this.label.dataset.fertig;
    if (fehler) this.ablehnen(fehler);
    else if (this.datei) this.gewaehlt(this.datei, true, true);
    else this.leer();
  };

  function start() {
    document.querySelectorAll('label.inst-datei').forEach(function (l) {
      if (!l.instDropzone && l.querySelector('input[type="file"]')) new Dropzone(l);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
